import Player from 'xgplayer';
import HlsLiveMsePlayer from './mse'
import HlsLiveMobilePlayer from './mobile'
import { EVENTS } from 'xgplayer-helper-utils'
// import 'xgplayer-mobilevideo'

export default class HlsLivePlayer {
  constructor (config) {
    if (HlsLiveMobilePlayer.isSupported() && config.useWASM) {
      return new HlsLiveMobilePlayer(config)
    } if (HlsLiveMsePlayer.isSupported()) {
      return new HlsLiveMsePlayer(config)
    } else {
      return new Player(config)
    }
  }

  static install (name, plugin) {
    return Player.install(name, plugin)
  }
}

HlsLivePlayer.EVENTS = EVENTS
